
export const timeRanges = [
    {name:'Posted any time'},
    {name:'Last day', count:25},
    {name:'Last 3 days', count:150},
    {name:'Last week', count:300},
    {name:'Last 2 weeks', count:900},
    {name:'Last month', count:3583} ,
  ]
    
  export const jobTypes = [
    {name:'All Job Types'},
    {name:'Full-time'},
    {name:'Part-time'},
    {name:'Contract'},
  ]
  
  export const priceRanges = [
    {name:'$500'},
    {name:'$3000'},
    {name:'$10.000'},
    {name:'$50.000'},
    {name:'$100.000'},
    {name:'$150.000'},
    {name:'$300.000'},
  ]
  